import { GhostButton } from '@axafr-btc-ds/buttons';

import { PreviousButtonProps } from './PreviousButton.interface';
import styles from './PreviousButton.module.css';

export function PreviousButton({ onClick }: PreviousButtonProps): JSX.Element {
    return (
        <GhostButton
            onClick={ onClick }
            className={ styles.previousButton }
        >
            Retour
        </GhostButton>
    );
}
